import React__default from 'react';
import PropTypes from 'prop-types';
import { n as nodeOrStringProp } from './PropTypes-9aad034b.js';
import 'moment';

function DescriptionList(props) {
  var className = props.className,
    items = props.items;
  return /*#__PURE__*/React__default.createElement("dl", {
    className: "bf-description-list-wrapper ".concat(className)
  }, items.map(function (item, index) {
    if (item) {
      var key = "ITEM_".concat(index);
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
        key: key
      }, /*#__PURE__*/React__default.createElement("dt", null, item.title), /*#__PURE__*/React__default.createElement("dd", null, item.content));
    }
    return null;
  }));
}
DescriptionList.defaultProps = {
  className: ''
};
DescriptionList.propTypes = {
  /**
  Description list elements. Each item must have a title and a content
   */
  items: PropTypes.arrayOf(PropTypes.shape({
    title: nodeOrStringProp.isRequired,
    content: nodeOrStringProp.isRequired
  })).isRequired,
  /**
  Custom className
   */
  className: PropTypes.string
};

export default DescriptionList;
